<template>
  <div class="learningRecord app-content">
    <div class="head-box">
      <span>当前位置： </span>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/">学习记录</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="当前学习课时" name="0">
          <div id="loadingBox0">
            <div v-if="noLearningData.length > 0">
              <!--            <learning-list :learningList="noLearningList" :showPlay="true"></learning-list>-->
              <learned-new :learningList="noLearningData" :showPlay="true"></learned-new>
              <!--            <pagination :total="noLearningData.totalCount" :pageSize=8 :currentChange="currentChangeNo"></pagination>-->
            </div>
            <div class="noneList" v-else>暂时无学习记录</div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="已完成学习课程" name="1">
          <div id="loadingBox1">
            <div v-if="finishLearningData.length > 0">
              <learned-new :learningList="finishLearningData" :showPlay="true"></learned-new>
              <!--            <learned-list :learnedList="finishLearningList" :showPlay="true"></learned-list>-->
              <!--            <pagination :total="finishLearningData.totalCount" :pageSize=8 :currentChange="currentChange"></pagination>-->
            </div>
            <div class="noneList" v-else>暂时无已完成学习记录</div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import learningList from '../components/learningList'
import learnedList from '../components/learnedList'
import pagination from '../components/pagination'
import learnedNew from '../components/learnedNew'
import { mapState } from 'vuex'

export default {
  name: 'learningRecord',
  components: {
    learningList,
    learnedList,
    pagination,
    learnedNew
  },
  computed: {
    ...mapState(['answerVisible', 'playVisible'])
  },
  data () {
    return {
      activeName: '0',
      noLearningList: [],
      finishLearningList: [],
      noLearningData: '',
      finishLearningData: '',
      // 未完成分页参数
      pageNo: 1,
      // 已完成分页参数
      page: 1
    }
  },
  mounted () {
    this.getLearning(0, 1)
  },
  methods: {
    handleClick (tab, event) {
      this.finishLearningList = []
      this.noLearningList = []
      if (this.activeName === '0') {
        this.page = 1
        this.getLearning(0, this.pageNo)
      } else if (tab.index === '1') {
        this.pageNo = 1
        this.getLearning(1, this.page)
      }
    },
    getLearning (type, page) {
      let that = this
      // this.$http({
      //   method: 'GET',
      //   url: '/api/renren-fast/app/olcurriculumstagemx/mxInfoByDoing',
      //   // url: '/api/renren-fast/app/olstudyrecord/list',
      //   params: {
      //     'olFinish': type,
      //     'page': page,
      //     'limit': 8
      //   }
      // }).then(result => {
      //   if (result.data.code === 0) {
      //     if (Number(type) === 0) {
      //       that.noLearningList = result.data.data.list ? result.data.data.list : []
      //       that.noLearningData = result.data.data
      //     } else {
      //       that.finishLearningList = result.data.data.list ? result.data.data.list : []
      //       that.finishLearningData = result.data.data
      //     }
      //   }
      // })
      const loading = this.$loading({
        lock: true,
        target: '#loadingBox' + type,
        text: '正在加载中',
        spinner: 'el-icon-loading'
      })

      this.$http({
        method: 'GET',
        url: '/api/renren-fast/app/olcurriculum/olCurriculumMxInfoByUser',
        // url: '/api/renren-fast/app/olstudyrecord/list',
        params: {
          'finish': type
        }
      }).then(result => {
        if (result.data.code === 0) {
          if (Number(type) === 0) {
            // that.noLearningList = result.data.data.stageInfoList ? result.data.data.stageInfoList : []
            that.noLearningData = result.data.data
          } else {
            // that.finishLearningList = result.data.data.stageInfoList ? result.data.data.stageInfoList : []
            that.finishLearningData = result.data.data
          }
          loading.close()
        }
      })
    },
    currentChange (val) {
      this.page = val
      this.getLearning(this.activeName, val)
    },
    currentChangeNo (val) {
      this.pageNo = val
      this.getLearning(this.activeName, val)
    }
  },
  watch: {
    answerVisible (val) {
      if (!val) {
        this.getLearning(this.activeName)
      }
    },
    playVisible (val) {
      if (!val) {
        this.getLearning(this.activeName)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.learningRecord{
  width: 1200px;
  margin: 0 auto;
  .content{
    margin: 20px 0px;
    .title{
      font-size: 24px;
      font-weight: bold;
      color: #666;
      margin-bottom: 20px;
    }
    .noneList{
      width: 100%;
      height: 300px;
      text-align: center;
      line-height: 300px;
    }
  }
}
.checkButton{
  border: #00c5c3;
  border-radius: 25px;
  background-color: #00c5c3;
  font-size: 15px !important;
  padding: 10px 20px 10px 20px;
  color: white !important;
}
.unCheckButton{
  border: 2px solid #00c5c3;
  border-radius: 25px;
  background-color: white;
  font-size: 15px !important;
  padding: 10px 20px 10px 20px;
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/view/learningRecord.vue